import Marionette from 'backbone.marionette';
import Navigator from '../../app';
import LoadingController from './loading_controller';
var API = {
  createSpinner: function () {
    LoadingController.createSpinner();
  },
  showSpinner: function () {
    LoadingController.showSpinner();
  },
  hideSpinner: function () {
    LoadingController.hideSpinner();
  }
};
Navigator.on("before:start", function () {
  API.createSpinner();
});
Navigator.vent.on("loading:show", function () {
  API.showSpinner();
});
Navigator.vent.on("loading:hide", function () {
  API.hideSpinner();
});